import React, { FC, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import {
  Input,
  Button,
  Modal,
  Row,
  Col,
  Dropdown,
  Menu,
  Switch,
  Radio,
} from "antd";
import { SearchOutlined, EllipsisOutlined } from "@ant-design/icons";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";

import {
  GET_FRIEND_PAGE,
  GET_PAGE,
  GET_USERS_LIST,
} from "reducers/authReducer";
import { RootState } from "reducers/rootReducer";
import {
  wrapRequestPayload,
  getMessageRequestPayload,
} from "../../helpers/request/RequestPayload";
import AddGroupModal from "components/Modals/AddGroupModal";
import InvitePeopleModal from "components/Modals/InvitePeopleModal";

import useLocalStorageService from "../../services/localStorage";
import { SocketTopics } from "../../constants/enums";
import { CID, UUID, RID } from "../../constants/localStoreKeys";
import { ReactSVG } from "react-svg";

import {
  getModifyPageSubscriptionTopic,
  getMembersRemoveFromPagePublishTopic,
} from "hooks/MQTTConstants";

import { generateUUID } from "utils/appUtil";

let timeout: NodeJS.Timeout;

function formatUserFilterText(text) {
  var result = "";
  let comp = text
    .trim()
    .split(" ")
    .filter((word) => word.length > 2)
    .map((x) => {
      return formatForRedis(x) + "*";
    });
  if (comp.length == 0) {
    return result;
  }

  comp.forEach((element) => {
    result += `@firstName:(${element})|@lastName:(${element})|`;
  });
  console.log("comp here", comp);
  result += `@beamIds:{${comp.join("|")}}`;

  return `(${result})`;
}

// function getFriendPageRequest(data) {
//   const obj = unwrapAsObject(data);
//   var result = {};

//   if (!obj.friendId) {
//       result.error = "Friend user ID is required";
//   } else {
//       var searchQuery = `@pageType:{friend}@pageMembers:{${connectionData.rootUserId}}@pageMembers:{${obj.friendId}}`;

//       result = {
//           responseTopic: `${connectionData.ecosystem}/connection/${connectionData.connectionId}/service/live/searchPage/reply`,
//           requestList: [
//               {
//                   topic: `${connectionData.ecosystem}/connection/${connectionData.connectionId}/service/live/searchPage`,
//                   payload: {
//                       paths: ["$"],
//                       returnPaths: ["$"],
//                       searchIndex: "beamdev:pageUpdatedAtIndex",
//                       searchQuery: searchQuery,
//                       searchOptions: "SORTBY updatedAt DESC"
//                   }
//               }
//           ]
//       }
//   }

//   return JSON.stringify(result);
// }

function formatForRedis(text) {
  return text.replace(/-|_|\./g, function (x) {
    return `\\${x}`;
  });
}

const PeopleListModal: FC<{ onClose: () => void; socket?: ISocket }> = ({
  onClose,
  socket,
}) => {
  const { selectedItem, userSearchPage } = useSelector(
    (state: RootState) => state.search
  );
  const { users, findUsersToPage, searchBds, allUsers } = useSelector(
    (state: RootState) => state.auth
  );
  const scrollRef = useRef(null);
  const [isModalVisible, setIsModalVisible] = useState(true);
  const [groupModalOpen, setgroupModalOpen] = useState(false);
  const [inviteModalOpen, setinviteModalOpen] = useState(false);
  const { projects } = useSelector((state: RootState) => state.dashboard);
  const { adminRoles } = useSelector((state: RootState) => state.dashboard);
  const { requestIds } = useSelector((state: RootState) => state.dashboard);

  // const [allUsers, setAllUsers] = useState([]);
  // const [selectedUsers, setSelectedUsers] = useState<UserInfo[]>(
  const [selectedUsers, setSelectedUsers] = useState<any[]>([
    { id: localStorage.getItem("RID") },
  ]);
  const handleCancel = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };

  const dispatch = useDispatch();

  const { getLocalStorageItem } = useLocalStorageService();

  const findUsers = (serviceId) => {
    // let serviceId = ["cudb-live"];
    const queryId = generateUUID();
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
        "CID"
      )}/service/live/findUsersToPage`,
      wrapRequestPayload(
        {
          userId: localStorage.getItem("RID"),
          cudbServiceId: serviceId,
          // modes: ["liveMember", "liveFriend", ...Object.assign([], serviceId.length > 0 ? ['cudb']: [])],
          // modes: [...Object.assign([], serviceId.length > 0 ? ['cudb']: [])],
          modes: ["liveMember", "allNotLiveCudb"],
        },
        queryId
      )
    );

    console.log("test findUsersToPage", {
      userId: localStorage.getItem("RID"),
      cudbServiceId: serviceId,
      modes: [
        "liveFriend",
        "liveMember",
        ...Object.assign([], serviceId.length > 0 ? ["cudb"] : []),
      ],
      // modes: ["liveFriend", "liveMember", "allNotLiveCudb"],
      // queryId: queryId,
    });
  };

  // const searchUser = (inputQueryId: string, filterText?: string) => {
  //   let serviceId = "cudb-live";
  //   var searchQuery = `@userType:{user}@serviceId:{${formatForRedis(
  //     serviceId
  //   )}}`;
  //   if (filterText && filterText.length > 2) {
  //     searchQuery += formatUserFilterText(filterText);
  //   }
  //   socket.publishToEvent(
  //     SocketTopics.PublishPageTopics,
  //     `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
  //       "CID"
  //     )}/service/bds/searchBds`,
  //     wrapRequestPayload({
  //       pagination: { offset: 0, limit: 100 },
  //       searchIndex: "beamdev:userNameIndex",
  //       searchQuery: searchQuery,
  //       searchOptions: "SORTBY beamIds ASC",
  //       inputQueryId,
  //     })
  //   );
  // };

  const aggregateUser = (inputQueryId: string, filterText?: string) => {
    var searchQuery = `@userType:{user}`;
    if (filterText && filterText.length > 2) {
      searchQuery += formatUserFilterText(filterText);
    }
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
        "CID"
      )}/service/bds/aggregateBds`,
      wrapRequestPayload({
        select: {
          index: {
            searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:userNameIndex`,
            searchQuery: searchQuery,
            searchOptions: "TIMEOUT 10000",
          },
          list: {
            inputQueryId: inputQueryId,
          },
          load: {
            objectId: "$.objectId",
            liveObject: "$.persistent.static",
            status: "$.nonpersistent.static.live.status"
          },
        },
        groupBy: {
          properties: ["@objectId"],
          reducers: [
            {
              func: "TOLIST",
              arguments: ["@liveObject"],
              name: "profile",
            },
          ],
        },
        apply: {
          expression: "",
          name: "",
        },
        filter: {
          expression: "",
        },
        result: {
          pagination: {
            offset: 0,
            limit: 10000,
          },
        },
        anyStatus: false,
      }, requestIds.user)
    );
  };

  useEffect(() => {
    if (!findUsersToPage) {
      // findUsers();
      findUsers([projects?.userServiceId]);
    }
  }, []);

  useEffect(() => {
    if (findUsersToPage) {
      aggregateUser(findUsersToPage.queryId);
    }
  }, [findUsersToPage]);

  useEffect(() => {
    if (searchBds) {
      console.log("all users", searchBds);
    }
  }, [searchBds]);

  const sendPageUpdateEvent = (type, attributes) => {
    const modifyPagePayload: IMessage = getMessageRequestPayload(
      getLocalStorageItem(CID),
      getLocalStorageItem(RID),
      selectedItem.pageId,
      "",
      type,
      attributes
    );
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getModifyPageSubscriptionTopic(selectedItem.pageId),
      wrapRequestPayload(modifyPagePayload)
    );
  };

  const addUser = (user) => {
    // const users = { ...selectedUsers, [user.id]: { role: "write" } };
    // let expiresAt = new Date();
    // expiresAt.setDate(expiresAt.getDate() + 1);
    // setSelectedUsers(users);
    // sendPageUpdateEvent("addPageMember", {
    //   userId: user.id,
    //   beamId: user.beamId || `${user.firstName}.${user.lastName}`,
    //   role: "write",
    //   pending: {
    //     invited: true,
    //     expiresAt: expiresAt.getTime(),
    //   },
    // });
    // if (scrollRef) {
    //   scrollRef.current.scrollTop = 0;
    // }

    dispatch(GET_FRIEND_PAGE({ friendUserId: user.id }));
    handleCancel();
  };

  const getUser = (userObj) => {
    const user = allUsers?.find((obj) => obj.id === userObj.id);
    console.log("user", user);
    return (
      <Col span={13}>
        <h5>
          {user && user.beamId
            ? user.beamId
            : userObj?.beamId && userObj?.beamId !== ""
            ? userObj?.beamId
            : `user #${userObj.id}`}
        </h5>
        {/* <p>{user?.email ?? "-"}</p>
        <p>{user?.phone ?? "-"}</p> */}

        <p>{getRole(user) || "-"}</p>
        <p>{user.department || "-"}</p>
      </Col>
    );
  };

  const editMenu = (id, user) => {
    const groups =
      selectedItem?.persistent?.static?.metadata?.members?.groups ?? {};
    const userGroups = [];
    Object.keys(groups).map((groupName) => {
      if ((groups[groupName]?.userIds ?? []).indexOf(id) !== -1)
        userGroups.push(groupName);
    });
    return (
      <div className="menu-container edit-menu ml-auto people-dropdown">
        <div className="menu-item">
          <Radio.Group
            defaultValue={user.role}
            onChange={(event) => {
              sendPageUpdateEvent("updatePageMemberRole", {
                userId: id,
                role: event.target.value,
              });
            }}
          >
            {["edit", "read", "write"].map((item) => (
              <Radio.Button value={item} key={item}>
                {item}
              </Radio.Button>
            ))}
          </Radio.Group>
        </div>
        <div
          className="menu-item"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "end",
          }}
        >
          {Object.keys(groups).map((groupName, idx) => (
            <React.Fragment>
              <p style={{ color: "#fff" }}>{groupName}</p>{" "}
              <Switch
                defaultChecked={
                  userGroups.indexOf(groupName) !== -1 ? true : false
                }
                onChange={(checked) => {
                  sendPageUpdateEvent(
                    checked ? "addGroupMember" : "removeGroupMember",
                    {
                      userId: id,
                      group: groupName,
                    }
                  );
                }}
              />
            </React.Fragment>
          ))}
        </div>
      </div>
    );
  };

  const getRole = (userObj) => {
    const role = adminRoles?.find((x) => {
      return x._id === userObj?.roleId;
    });
    return role?.name;
  };

  return (
    <React.Fragment>
      <Modal
        title=""
        visible={isModalVisible}
        onOk={() => {}}
        onCancel={handleCancel}
        width="480px"
        className="beam-modal scrollable"
        footer={[]}
        closable={false}
        destroyOnClose={true}
      >
        <Row className="d-flex mt-1 mb-4">
          <Col>
            <h3>People</h3>
          </Col>
          {/* {selectedItem && selectedItem.currentUserRole === "edit" && (
            <Col>
              <Button
                className="beam-btn blue-btn cover"
                onClick={() => {
                  setgroupModalOpen(true);
                }}
              >
                Create new Group
              </Button>
            </Col>
          )} */}
        </Row>
        <Row>
          <Col span={24}>
            <Input
              onChange={(e) => {
                const value: string = e.target.value;
                if(value === undefined || value === '')return;
                if (timeout) clearTimeout(timeout);
                timeout = setTimeout(() => {
                  // dispatch(GET_USERS_LIST(value));
                  if (findUsersToPage) {
                    aggregateUser(findUsersToPage.queryId, value);
                  }
                  // dispatch(GET_PAGE({ search: value }));
                }, 500);
              }}
              placeholder="Search"
              suffix={<SearchOutlined />}
            />
          </Col>
        </Row>
        <Row className="scrollable-body mt-4" ref={scrollRef}>
          <Col span={24}>
            <React.Fragment>
              <Row className="d-flex mt-4 mb-4">
                <Col>
                  <h5>People</h5>
                </Col>
              </Row>
              {searchBds &&
                searchBds.map(
                  (user, index) =>
                    !Object.keys(selectedUsers).find(
                      (item) => item === user.id
                    ) && (
                      <Row className="person-item" key={index}>
                        <Col span={5}>
                          <img
                            src={
                              user?.profileImage?.urls?.original?.url ??
                              "/images/users/user.png"
                            }
                            width="45"
                            height="45"
                          />
                        </Col>
                        <Col span={10}>
                          <h5>{user.beamId}</h5>
                          {/* <p>{user.email || "-"}</p>
                          <p>{user.phone || "-"}</p> */}
                          <p>{getRole(user) || "-"}</p>
                          <p>{user.department || "-"}</p>
                        </Col>
                        <Col span={9} className="t-right">
                          <Button
                            className="beam-btn green-btn"
                            onClick={() => addUser(user)}
                          >
                            Private chat
                          </Button>
                        </Col>
                      </Row>
                    )
                )}
            </React.Fragment>
          </Col>
        </Row>
      </Modal>
    </React.Fragment>
  );
};

export default PeopleListModal;
